/* 🤖 this file was generated by svg-to-ts */
export const emperorIconDelete: {
  name: 'delete';
  data: string;
} = {
  name: 'delete',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M19.077 4.929c-1.89-1.89-4.41-2.93-7.08-2.93 -2.68 0-5.19 1.04-7.08 2.92 -1.89 1.88-2.93 4.4-2.93 7.07s1.041 5.18 2.93 7.07c1.88 1.88 4.4 2.92 7.07 2.92s5.182-1.04 7.071-2.93c3.89-3.901 3.89-10.25 0-14.144Zm-.76 11.97l-4.9-4.91 4.901-4.9c2.23 2.87 2.23 6.926-.01 9.8Zm-1.42-11.22l-4.91 4.901L7.08 5.679c1.39-1.09 3.1-1.686 4.9-1.686 1.8 0 3.5.59 4.9 1.686ZM3.99 11.993c0-1.8.59-3.51 1.686-4.9l4.901 4.9 -4.901 4.9c-1.09-1.4-1.686-3.11-1.686-4.91Zm3.1 6.31l4.9-4.901 4.9 4.901c-1.4 1.08-3.1 1.68-4.9 1.68 -1.8 0-3.51-.6-4.91-1.69Z"/></svg>`,
};
